import React from "react";
import { getOrderId, getOrderDate } from "./order";

const Row = ({ item, checked, onCheckboxChange, onRowClick, isActive }) => (
  <tr
    onClick={onRowClick}
    onKeyDown={(event) => {
      if (event.key === " " || event.key === "Spacebar") {
        event.preventDefault();
        onCheckboxChange(!checked);
      }
    }}
    tabIndex={0}
    style={{ cursor: "pointer", background: checked ? "#e6f2ff" : isActive ? "#f7fbff" : "transparent" }}
  >
    <td style={{ padding: 8 }}>
      <input
        type="checkbox"
        aria-label={`Select order ${getOrderId(item)}`}
        checked={checked}
        onChange={event => onCheckboxChange(event.target.checked)}
        onClick={event => event.stopPropagation()}
      />
    </td>
    <td style={{ padding: 8, whiteSpace: "nowrap" }}>{getOrderDate(item)}</td>
    <td style={{ padding: 8 }}>{getOrderId(item)}</td>
  </tr>
);

export default Row;
